import { useEffect } from "react";

// Incorpora inline (senza iframe) un documento legale Iubenda.
export const IubendaEmbed = ({ url, label }) => {
  useEffect(() => {
    const s = document.createElement("script");
    s.src = "https://cdn.iubenda.com/iubenda.js";
    s.async = true;
    document.body.appendChild(s);
    return () => {
      try { document.body.removeChild(s); } catch (e) { /* noop */ }
    };
  }, [url]);

  return (
    <div className="iubenda-wrap [&_a]:text-lavender-deep">
      <a
        href={url}
        className="iubenda-white no-brand iubenda-noiframe iubenda-embed iub-body-embed"
        title={label}
        data-testid="iubenda-embed-link"
      >
        {label}
      </a>
    </div>
  );
};
